
import { Component, Vue } from 'vue-property-decorator';
import Events from '@/active-components/dashboard/Events.vue';
import Sheets from '@/active-components/dashboard/Sheets/Sheets.vue';

@Component({
    components: {
        Events,
        Sheets,
    },
})
export default class Dashboard extends Vue {
    activeTab = 0;
}
